/**
 *  @class
 *  @function CartRemove
 */
if (!customElements.get('cart-remove')) {
  class CartRemove extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        event.preventDefault();
        this.dispatchEvent(new CustomEvent('cart:remove', {
          bubbles: true,
          detail: { index: this.dataset.index }
        }));
      });
    }
  }
  customElements.define('cart-remove', CartRemove);
}